import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row mx-5" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card p-0 border-light" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "btn btn-danger" }

import { onMounted, ref } from "vue";
import { BackupInSession } from "../../utils/BackupInSession";
import { SessionUser } from "../../utils/SessionUser";
import { dayjs, DTW_FORMAT_JA_SHORT } from "../../../framework/util/momentExtends";
import { NumberUtils } from "../../utils/NumberUtils";
import OptionPageHeader from "../../components/header/OptionPageHeader.vue";
import { DialogHandler } from "../../components/dialog/DialogHandler";
import RecoverBackupDialog from "../../components/dialog/RecoverBackupDialog.vue";
import { blocklyStore } from "../../blockly/blocklyStore";
import { VrockFileHandler } from "../../utils/VrockFileHandler";
import { translation } from "../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecoverBackupPage',
  setup(__props) {

const t = translation;

/**
 * 動的ラベル
 */
const backupRecoverSize = t.to("サイズ", "size");

/**
 * プロパティ
 */
const pageTitle = t.to(
  "このログイン中に保存したプロジェクト（直近100件）",
  "backup_recovery_title"
);

onMounted(() => {
  blocklyStore.workspace.clear();
});

class LogExt extends VrockFileHandler {
  log_date_obj: string;
  length: string;
  image: string;
}

/**
 * LoadData
 */
const backup = new BackupInSession();
const logs = backup
  .getLogs()
  .sort((a, b) => {
    if (a.log_date > b.log_date) return -1;
    if (a.log_date < b.log_date) return 1;
    return 0;
  })
  .map((item) => {
    (item as LogExt).log_date_obj = dayjs(item.log_date).format(DTW_FORMAT_JA_SHORT);
    (item as LogExt).length = NumberUtils.humanReadableFileSize(
      JSON.stringify(item).length
    );
    (item as LogExt).image = `/assets/${SessionUser.instance.userId}/project/${item.project_id}.png`;
    return item as LogExt;
  });

/**
 * リカバリボタン
 */
const recoveryTitle = t.to("リカバリ", "recovery");

const selectedItem = ref(null);
const openRecoveryDialog = (item) => {
  DialogHandler.showRecoverBackupDialog(item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(OptionPageHeader, { class: "mx-5" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logs), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.log_date_obj,
          class: "col-sm-6 col-md-4",
          onClick: ($event: any) => (openRecoveryDialog(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, "ID : " + _toDisplayString(item.project_id), 1),
              _createElementVNode("div", null, _toDisplayString(item.log_date_obj), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(backupRecoverSize)) + " : " + _toDisplayString(item.length), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", _hoisted_5, _toDisplayString(_unref(recoveryTitle)), 1)
              ])
            ])
          ])
        ], 8, _hoisted_2))
      }), 128))
    ]),
    _createVNode(RecoverBackupDialog, { "selected-item": selectedItem.value }, null, 8, ["selected-item"])
  ], 64))
}
}

})